import './RightPanel.scss';
import { withLoadPanel } from '../../../utils/withLoadPanel';
import { PanelDetails } from './RightPanelDetails';
import { ReactNode } from 'react';

const PanelWithLoadPanel = withLoadPanel(PanelDetails);

export const RightPanel = ({ children, lockOnDesktop }: { children?: ReactNode; lockOnDesktop?: boolean }) => {
  return (
    <PanelWithLoadPanel
      hasData={true}
      lockOnDesktop={lockOnDesktop}
      panelProps={{
        position: { of: '.panel' },
        container: '.panel',
      }}>
      {children}
    </PanelWithLoadPanel>
  );
};
